import React from 'react';
import { isFavorite, toggleFavorite } from '../utils/favorites';
import { Heart, Eye } from 'lucide-react';

function RecipeCard({ recipe, onViewDetails, onFavoriteChange }) {
    const handleFavoriteClick = (e) => {
        e.stopPropagation();
        const newFavorites = toggleFavorite(recipe);
        if (onFavoriteChange) {
            onFavoriteChange(newFavorites);
        }
    };

    const handleCardClick = () => {
        if (onViewDetails) {
            onViewDetails(recipe);
        }
    };

    const isLiked = isFavorite(recipe.idMeal);

    return (
        <div className="recipe-card" onClick={handleCardClick}>
            <div className="recipe-card-image">
                <img
                    src={recipe.strMealThumb}
                    alt={recipe.strMeal}
                    loading="lazy"
                />
            </div>

            <div className="recipe-card-content">
                <h3 className="recipe-card-title">{recipe.strMeal}</h3>

                <div className="recipe-card-tags">
                    {recipe.strCategory && (
                        <span className="recipe-tag category-tag">{recipe.strCategory}</span>
                    )}

                    {recipe.strArea && (
                        <span className="recipe-tag area-tag">{recipe.strArea}</span>
                    )}
                </div>
            </div>

            <div className="recipe-card-actions">
                <button
                    className={`favorite-btn ${isLiked ? 'liked' : ''}`}
                    onClick={handleFavoriteClick}
                    aria-label={isLiked ? 'Remove from favorites' : 'Add to favorites'}
                >
                    <Heart size={16} fill={isLiked ? '#8b5cf6' : 'none'} />
                </button>

                <button
                    className="view-btn"
                    onClick={handleCardClick}
                    aria-label="View recipe details"
                >
                    <Eye size={16} />
                </button>
            </div>
        </div>
    );
}

export default RecipeCard;